
#  require jquery-ujs
# require services/jquery.magnific-popup
  
#  require jquery-ui/ui/core
#  require jquery-ui/ui/widget
#  require jquery-ui/ui/widgets/mouse
#  require jquery-ui/ui/widgets/draggable
#  require jquery-ui/ui/widgets/slider
#  require jquery-ui/ui/widgets/accordion



# require social_network/fluidbook

$(document).on 'ready' , ->
  $("#form_submit_btn").on 'click touchstart', ->
    #$("#form_submit_btn").bind "tap", ->
    all_input_are_filled = true
    $('#contact_modal input').each ->
      if !$(this).val()
        alert 'Tous les champs doivent être remplis'
        all_input_are_filled = false
        return false
    if all_input_are_filled == true
      $('#captcha_form').show()
      $('#form_submit_btn').hide()

  $("#form_submit_btn1").on 'click', ->
    #$("#form_submit_btn").bind "tap", ->
    all_input_are_filled = true
    if($('#commercial_contact_name').val() == "" ||  $('#commercial_contact_organization').val() == "" ||  $('#commercial_contact_phone_number').val() == "" || $('#commercial_contact_email').val() == "" || $('#commercial_contact_notes').val() == "")
      alert 'Tous les champs doivent être remplis'
      all_input_are_filled = false
      return false
    if all_input_are_filled == true
      $('#captcha_form').show()
      $('#form_submit_btn1').hide()
      
  $('.yearbook_turn, .yearbook_turn_small').each ->
    el = $(this).attr('yearbook')
    $(this).magnificPopup
      items: {src: '#flipbook_container_'+el}
      type: 'inline'
      closeBtnInside: false
      closeOnBgClick: false
      callbacks: {
        open: () ->
          $('#flipbook_container_'+el + ' img').each ->
            $(this).attr('src', $(this).data('src2'))
            $(this).removeAttr('data-src2')
      }
  $(".go_top").on 'click', ->
    document.body.scrollTop = 0;   
    document.documentElement.scrollTop = 0; 
  
  if $('.modal_commercial_contact').length
    
    modal = bootstrap.Modal.getOrCreateInstance('#modal_commercial_contact')
    modal.show()
    
  $(".change_img").on 'click', -> 
    $(".hidden_li").hide();
    $(".img_bons_plans").show();
    $(".hidden_li_concept").hide();
    $(".img_concept").show();
    $(".img_blog").hide();
    $(".hidden_li_blog").show();
    $(".img_yearbooks").hide();
    
    $(".hidden_li_yearbooks").show();


    

  $(".concept").on 'click', -> 
    $(".hidden_li_concept").show();
    $(".img_concept").hide();
    $(".hidden_li").show();
    $(".img_bons_plans").hide();
    $(".img_blog").hide();
    $(".img_yearbooks").hide();
    $(".hidden_li_yearbooks").show();

  #$(".blog_link").on 'click', -> 
  #  $(".hidden_li_blog").hide();
  #  $(".img_concept").show();
  #  $(".hidden_li").show();
  #  $(".img_bons_plans").hide();
  #  $(".img_blog").show();
  #  $(".hidden_li_concept").hide();
  #  $(".img_yearbooks").hide();
  #  $(".hidden_li_yearbooks").show();
  
  $(".yearbooks").on 'click', -> 
    $(".hidden_li_blog").show();
    $(".img_concept").hide();
    $(".hidden_li").show();
    #$(".img_bons_plans").hide();
    #$(".img_blog").hide();
    $(".hidden_li_concept").show();
    $(".img_yearbooks").show();
    $(".hidden_li_yearbooks").hide();
    $(".img_yearbooks_hover").show();
    $(".size_bonplans").show();
    $(".change_img").show();

  $(".btn_entreprise").on 'click', -> 
    $(".ecoles_yearbooks").hide();
    $(".entreprise_yearbooks").show();
    $('.btn_ecoles').removeClass('btn_active');
    $('.btn_entreprise').addClass('btn_active');
  
  $(".btn_ecoles").on 'click', -> 
    $(".ecoles_yearbooks").show();
    $(".entreprise_yearbooks").hide();
    $('.btn_ecoles').addClass('btn_active');
    $('.btn_entreprise').removeClass('btn_active');
  
 
  
      
  $('.album_show').click ->
    $('.list_album').toggle();
    $('.album_show').toggleClass 'border-album'
    return
  return
 
 

  $(".create_compte h3").on 'click', -> 
    $(".mentions_compte").hide();
    

  

    
  #datePickerId.min = new Date().toISOString().split("T")[0];

  $('[data-toggle="tooltip"]').tooltip({
    trigger : 'hover'
  })
  

  
  
